var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.menu.parent.isShow && _vm.menu.parent.href
        ? _c(
            "router-link",
            {
              staticClass: "div--menu",
              class: {
                "div--active": _vm.ishrefEqualToRoute(_vm.menu.parent.href)
              },
              attrs: { to: _vm.menu.parent.href, "exact-path": "", tag: "div" }
            },
            [
              _c("a", { staticClass: "a--none color--white" }, [
                _c("div", { staticClass: "sidemenu-container" }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/icon-sidebar/" +
                        _vm.menu.parent.icon +
                        ".svg"),
                      height: "25"
                    }
                  }),
                  _vm._v(" "),
                  _vm.minimized
                    ? _c("span", { staticClass: "nav-text toggleable" }, [
                        _vm._v("  " + _vm._s(_vm.menu.parent.name) + " ")
                      ])
                    : _vm._e()
                ])
              ])
            ]
          )
        : _vm.menu.parent.isShow && _vm.menu.parent.hrefout
        ? _c(
            "div",
            {
              class: {
                "div--active": _vm.ishrefoutEqualToWindowLocation(
                  _vm.menu.parent.hrefout
                )
              }
            },
            [
              _c(
                "a",
                {
                  staticClass: "a--none color--white",
                  attrs: { href: _vm.menu.parent.hrefout }
                },
                [
                  _c("div", { staticClass: "sidemenu-container" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/icon-sidebar/" +
                          _vm.menu.parent.icon +
                          ".svg"),
                        height: "25"
                      }
                    }),
                    _vm._v(" "),
                    _vm.minimized
                      ? _c("span", { staticClass: "nav-text toggleable" }, [
                          _vm._v("  " + _vm._s(_vm.menu.parent.name) + " ")
                        ])
                      : _vm._e()
                  ])
                ]
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f67f726", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f67f726","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/jNestedMenu.vue
// module id = null
// module chunks = 